module.exports = __webpack_public_path__ + "img/img_32389_0_455.6ab40400.png";